var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.infos),function(info){return _c('span',[_c('b-badge',{attrs:{"title":info.title,"variant":info.status}},[_vm._v("\n\t\t\t"+_vm._s(info.title)+"\n\t\t")])],1)}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82101dee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Orders_v2/Aggregates/BadgeInfo.vue
// module id = HglK
// module chunks = 0